import { render, staticRenderFns } from "./Depend.vue?vue&type=template&id=3be9af55"
import script from "./Depend.vue?vue&type=script&lang=js"
export * from "./Depend.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports